import { Observable, of } from 'rxjs'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  RouterStateSnapshot,
} from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, map, switchMapTo, take, tap, withLatestFrom } from 'rxjs/operators'
import * as fromRoot from '@tv3/store/state'
import { selectInquiriesLoaded, selectInquiryPagination } from '../store/inquiry/inquiry.selectors'
import { LoadInquiries } from '../store/inquiry/inquiry.actions'
import { IsDataLoaded } from '@tokeet/tv3-platform'

@Injectable({ providedIn: 'root' })
export class InquiryGuard implements CanActivate, CanActivateChild, CanLoad, IsDataLoaded {
  constructor(private store: Store<fromRoot.State>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectInquiriesLoaded),
      withLatestFrom(this.store.pipe(select(selectInquiryPagination))),
      tap(([isLoaded, pagination]) => {
        if (!isLoaded && pagination.hasMore) {
          this.store.dispatch(LoadInquiries({ pagination }))
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate()
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
